export default "__VITE_ASSET__BXYlyhAq__"